import http from '@/http/aisea/axios'
const resource = "/enterprise/plots";

export default {
  search(request) {
    return http.get(`${resource}`, {
      params: request
    });
  }
};
